// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promo-disabled{display:flex}.promo-disabled__icon{flex:0 0 16px;fill:#aeb4c2;margin-top:2px}.promo-disabled__text{font-size:13px;line-height:20px;color:#242424;margin:0}.promo-disabled__icon+.promo-disabled__text{margin-left:8px}", ""]);
// Exports
module.exports = exports;
